
import React from 'react'

import { useProject } from '@/Hooks/UseProject'
import { Link } from 'react-router-dom'

import './Footer.scss'

interface Props {
  menu: any[]
}

const Footer = ({ menu }: Props) => {

  const { project } = useProject()

  if(!project) return null

  return (
    <div className="footer-menu shadow-custom d-flex d-lg-none">
      <ul className="project-menu footer-menu__list">
        {menu.map((menuItem: any, i: number) => (
          <li key={i}>
            <Link
              className={`svg-icon-menu ${menuItem.active && "active"}`}
              to={menuItem.path}>
              <div className="svg-icon">
                <div className="svg-icon-container">
                  <span
                    className={`main-menu-icon ${menuItem.icon}${menuItem.active ? "_full" : ""
                      }`}></span>
                </div>
              </div>
              <p className="textMenu">{menuItem.text}</p>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  )
}

export default Footer
